import { render } from "./beneficiary_analytics_index.vue?vue&type=template&id=2ac0ba2d&scoped=true&dir=rtl"
import script from "./beneficiary_analytics_index.vue?vue&type=script&lang=js"
export * from "./beneficiary_analytics_index.vue?vue&type=script&lang=js"

import "./beneficiary_analytics_index.vue?vue&type=style&index=0&id=2ac0ba2d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac0ba2d"]])

export default __exports__